import { useCurrentClient } from '@mysten/dapp-kit-react'
import { useQuery, useQueryClient } from '@tanstack/react-query'

import { PositionInfo, positionsQueryKey } from '@/shared/kai/hooks/useUserPositions'
import { useCurrentWalletAddress } from 'utils/useCurrentWalletAddress'

export const unclaimedRewardsQueryKey = (positionId: string) =>
  ['unclaimed-rewards', positionId] as const

export const useRewardsFeesInfo = (positionInfo: PositionInfo) => {
  const client = useCurrentClient()
  const queryClient = useQueryClient()
  const walletAddress = useCurrentWalletAddress()

  const { data, isLoading, error, refetch } = useQuery({
    queryKey: unclaimedRewardsQueryKey(positionInfo.positionId),
    queryFn: async () => {
      if (positionInfo.isDeleted) {
        return null
      }

      try {
        return await positionInfo.lastPosition.devInspectLpUnclaimedRewards(client)
      } catch (e) {
        // devInspect can fail when on-chain state has changed (position deleted,
        // object missing, etc.) but our cached data is stale. Invalidate positions
        // to pick up the latest state.
        void queryClient.invalidateQueries({ queryKey: positionsQueryKey(walletAddress) })
        throw e
      }
    },
    refetchInterval: 1000 * 60,
    staleTime: 1000 * 60,
  })

  return { result: data || null, isLoading, error, refetch }
}
